import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import css from './CreativeChartHeader.css';
import sharedCss from './sharedTabStyles.css';
import { Dropdown } from '../../../components/widgets';
import ToggleTabGroup from '../../../components/atoms/ToggleTabGroup';
import TopXChartDataFilter from '../../../components/partials/TopXChartDataFilter';

const CreativeChartHeader = ({
    title,
    dropdowns = [],
    tabs = [],
    selectedTab,
    onTabChange,
    onTopXChanged,
    showTopX = false,
    selectedTopX = 5,
    rowDataLength = 0,
    isTopXDisabled = false,
}) => {
    const toggleTabOptions = tabs.map(tab => ({
        option: tab.value,
        label: tab.label,
    }));

    const handleTabToggle = optionValue => {
        const clickedTab = tabs.find(tab => tab.value === optionValue);
        if (clickedTab) onTabChange(clickedTab);
    };

    return (
        <div className={css.header}>
            <span className={sharedCss.sectionTitle}>
                <Translate id={title} />
            </span>
            <div className={css.controls}>
                {!!tabs.length && (
                    <ToggleTabGroup
                        options={toggleTabOptions}
                        selectedOption={selectedTab?.value}
                        onToggle={handleTabToggle}
                    />
                )}
                {dropdowns.map((dropdown, index) => (
                    <div key={dropdown.label || `dropdown-${index}`} className={css.dropdownWrapper}>
                        {dropdown.label && (
                            <span className={css.dropdownLabel}>
                                <Translate id={dropdown.label} />
                            </span>
                        )}
                        <Dropdown
                            selected={dropdown.selected}
                            onSelection={dropdown.onChanged}
                            items={dropdown.options}
                            containerClass={css.dropdown}
                            selectedContainer={css.selectedDropdown}
                            bodyClassName={css.dropdownBody}
                        />
                    </div>
                ))}
                {showTopX && (
                    <TopXChartDataFilter
                        topXCount={selectedTopX}
                        rowDataLength={rowDataLength}
                        onChange={onTopXChanged}
                        withShowAll
                        className={css.topXWrapper}
                        labelClassName={css.topXLabel}
                        dropdownClassName={css.topXDropdown}
                        disabled={isTopXDisabled}
                    />
                )}
            </div>
        </div>
    );
};

CreativeChartHeader.propTypes = {
    title: PropTypes.string,
    dropdowns: PropTypes.arrayOf(
        PropTypes.shape({
            options: PropTypes.arrayOf(
                PropTypes.shape({
                    value: PropTypes.string,
                    label: PropTypes.string,
                })
            ),
            selected: PropTypes.shape({
                value: PropTypes.string,
                label: PropTypes.string,
            }),
            onChanged: PropTypes.func,
            label: PropTypes.string,
        })
    ),
    tabs: PropTypes.array,
    selectedTab: PropTypes.object,
    onTabChange: PropTypes.func,
    showTopX: PropTypes.bool,
    selectedTopX: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onTopXChanged: PropTypes.func,
    rowDataLength: PropTypes.number,
    isTopXDisabled: PropTypes.bool,
};

export default CreativeChartHeader;
